/* eslint-disable import/prefer-default-export */
export const smallScreen = () => {
    return window.screen.width <= 700;
};
